export const homeFaqItems = [
  {
    question: "What is DeokarMaratha.in Vadhu Var Search?",
    answer:
      "DeokarMaratha.in Vadhu Var Search is online brand of 'Marathi Vadhu Var Suchak', and simply free classified of 'Marathi Vadhu Var Suchak'.",
  },
  {
    question: "What are the benefits of DeokarMaratha.in Vadhu Var Search?",
    answer:
      "Well educated Maratha Vadhu Var can search and view profiles in short on just one click with profile photo.",
  },
  {
    question: "How could I add my profile on DeokarMaratha.in Vadhu Var Search list?",
    answer:
      "Simply register free on parent site 'MarathiVadhuVarSuchak.com'. After approval your profile will be display on DeokarMaratha.in list too.",
  },
  {
    question:
      "How could I see full profile viewed on DeokarMaratha.in Vadhu Var search?",
    answer:
      "First register free on parent website 'MarathiVadhuVarSuchak.com' and after approval you can see full profile, which was viewed on DeokarMaratha.in Vadhu Var search result.",
  },
  {
    question: "Can I use DeokarMaratha.in Vadhu Var search for free?",
    answer:
      "Yes! DeokarMaratha.in Vadhu Var search is free. However, its parent site 'MarathiVadhuVarSuchak.com' also allowed free registration.",
  },
] as const;
